import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { WebConfig } from "./web-config";
import { initClients } from "./services/api";
// Example global config object (define this somewhere properly)

async function fetchConfig() {
  const response = await fetch("/config.json");
  if (!response.ok) {
    throw new Error(`Failed to fetch configuration: ${response.statusText}`);
  }
  return response.json();
}

fetchConfig()
  .then((config) => {
    Object.keys(config).forEach((key) => {
      try {
        WebConfig[key.toUpperCase()] = config[key];
      } catch (err) {
        // eslint-disable-next-line no-console
        console.error("Config error:", key);
      }
    });
    initClients();
    const root = ReactDOM.createRoot(document.getElementById("root"));
    root.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>
    );
  })
  .catch((error) => {
    // eslint-disable-next-line no-console
    console.error("Error loading config:", error);
  });
